import { Button, Grid } from "@mui/material";
import { useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../components/base/BasicDialog";
import { SnackbarError } from "../../components/base/SnackbarAlert/SnackbarError";
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import { SELLER_SCOPES, SellerScopeSelect } from "../../components/form/SellerScopeSelect";
import { UserSelect } from "../../components/form/UserSelect";
import { useCreateSeller } from "../../services/usersApi";

export const SellerCreateDialog = (props) => {
    const { onClose, existingSellersUserIds = [] } = props;
    const { t } = useTranslation();

    const { mutate: createSeller } = useCreateSeller({
        onSuccess: () => {
            toast.custom(
                () => <SnackbarSuccess message={t("sellers.SellerCreateDialog.success")} />,
                { position: "bottom-right" },
            );
            onClose();
        },
        onError: () => {
            toast.custom(() => <SnackbarError message={t("sellers.SellerCreateDialog.error")} />, {
                position: "bottom-right",
            });
        },
    });

    const [userId, setUserId] = useState(null);
    const [sellerScope, setSellerScope] = useState(SELLER_SCOPES[0].key);

    const isFormValid = useMemo(() => {
        return userId !== null && sellerScope !== "";
    }, [userId, sellerScope]);

    const handleSubmit = () => {
        if (!isFormValid) {
            return;
        }
        createSeller({ user_id: userId, seller_scope: sellerScope });
    };

    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("sellers.SellerCreateDialog.title")}
            minWidth={400}
            maxWidth={"md"}
            showDialogActions
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <UserSelect
                        label={t("sellers.SellerCreateDialog.user")}
                        selectedUserId={userId}
                        setSelectedUserId={setUserId}
                        excludeUserIds={existingSellersUserIds}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SellerScopeSelect
                        label={t("sellers.SellerCreateDialog.scope")}
                        selectedScope={sellerScope}
                        setSelectedScope={setSellerScope}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button onClick={() => handleSubmit()} disabled={!isFormValid}>
                        {t("sellers.SellerCreateDialog.submit")}
                    </Button>
                </Grid>
            </Grid>
        </BasicDialog>
    );
};
